const testEvent: {
  [name: string]: () => boolean;
} = {
  passiveListener: () => {
    let supportsPassive = false;
    try {
      const opts = Object.defineProperty({}, 'passive', {
        // eslint-disable-next-line
        get() {
          supportsPassive = true;
        },
      });
      window.addEventListener(
        'test',
        <EventListenerOrEventListenerObject>(<unknown>null),
        opts,
      );
    } catch (e) {
      // No support
    }
    return supportsPassive;
  },
  smoothScroll: () => {
    return 'scrollBehavior' in document.documentElement.style;
  },
  touch: () => {
    return 'ontouchstart' in window;
  },
  mouse: () => {
    return 'onmousedown' in window;
  },
};

export function addTest(name: string, testFunc: () => boolean): void {
  testEvent[name] = testFunc;
}

export default function canUse(name: string): boolean {
  return testEvent[name]();
}

export function canUseEnterKeyHint() {
  return 'enterKeyHint' in document.createElement('input');
}
